(function () {
  function hasJJBeltsTag(tags) {
    if (!tags) return false;
    if (Array.isArray(tags)) return tags.includes('JJBelts');
    return tags.split(', ').includes('JJBelts');
  }

  function showDisclaimer(callback) {
    const overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:9999;display:flex;align-items:center;justify-content:center;';
    overlay.innerHTML = `
      <div style="background:#fff;padding:2rem;border-radius:8px;max-width:420px;text-align:center;font-family:inherit;">
        <h3 style="margin-top:0;">Product Disclaimer</h3>
        <p>Have you read the product disclaimer before adding this item to your cart?</p>
        <button id="jjb-confirm" style="background:#000;color:#fff;border:none;padding:0.75rem 1.5rem;border-radius:4px;cursor:pointer;margin-right:0.5rem;">Yes, I've read it</button>
        <button id="jjb-cancel" style="background:#eee;color:#000;border:none;padding:0.75rem 1.5rem;border-radius:4px;cursor:pointer;">Cancel</button>
      </div>`;
    document.body.appendChild(overlay);
    document.getElementById('jjb-confirm').onclick = function () { overlay.remove(); callback(true); };
    document.getElementById('jjb-cancel').onclick = function () { overlay.remove(); callback(false); };
  }

  function checkTagAndPrompt(variantId, proceedFn, cancelFn) {
    fetch('/variants/' + variantId + '.js')
      .then(r => r.json())
      .then(variant => fetch('/products/' + variant.product_id + '.js'))
      .then(r => r.json())
      .then(product => {
        if (hasJJBeltsTag(product.tags)) {
          showDisclaimer(confirmed => confirmed ? proceedFn() : cancelFn());
        } else {
          proceedFn();
        }
      })
      .catch(() => proceedFn()); // fail open
  }

  // Intercept fetch
  const originalFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url);
    if (url && url.includes('/cart/add')) {
      let body = {};
      try { body = JSON.parse((init && init.body) || '{}'); } catch (e) {}
      const variantId = body.id || (body.items && body.items[0] && body.items[0].id);
      if (variantId) {
        return new Promise((resolve) => {
          checkTagAndPrompt(
            variantId,
            () => resolve(originalFetch(input, init)),
            () => resolve(new Response(JSON.stringify({ error: 'Cancelled by user' }), { status: 422, headers: { 'Content-Type': 'application/json' } }))
          );
        });
      }
    }
    return originalFetch(input, init);
  };

  // Intercept form submissions as fallback
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form.action || !form.action.includes('/cart/add')) return;
    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    checkTagAndPrompt(
      variantInput.value,
      () => HTMLFormElement.prototype.submit.call(form),
      () => {}
    );
  }, true);
})();
